import { Schema } from 'effect';

import { GtmItemsArraySchema } from './items';
import { StringOptionalProperty } from '../primitive/string';

/**
 * Triggered when a user selects a promotion
 * Based on: https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#select_promotion
 */
export const GtmSelectPromotionEventSchema = Schema.Struct({
  event: Schema.Literal('select_promotion'),
  ecommerce: Schema.Struct({
    creative_name: StringOptionalProperty,
    creative_slot: StringOptionalProperty,
    promotion_id: StringOptionalProperty,
    promotion_name: StringOptionalProperty,
    items: GtmItemsArraySchema,
  }),
}).annotate({ identifier: 'GtmSelectPromotionEventSchema' });

export type GtmSelectPromotionEvent = Schema.Schema.Type<typeof GtmSelectPromotionEventSchema>;
